module.exports = __webpack_public_path__ + "assets/img/6651334868885cfcfd5c4900530c179e.png";